import {
  Alert,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const EmploynmentStateArkansas = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Colorado Payroll Tax Filing Requirements | TaxZerone"
          description="Learn about Colorado payroll tax filing requirements with TaxZerone. Get guidance on state forms, meet deadlines, and stay compliant with the state laws."
          keywords=" "
          canonical="employment-tax/state-payroll-tax/colorado-filing-requirements/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/colorado-payroll-img.webp" />
                <source srcSet="/assets/images/colorado-payroll-img.png" />
                <img
                  src="/assets/images/colorado-payroll-img.png"
                  alt="Colorado Payroll Tax Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Colorado</span>
                </span>{' '}
                Payroll Tax Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone helps employers in Colorado to understand and manage
                their state payroll tax filing requirements. Learn about the
                essential forms and their due dates to ensure your business
                remains in good standing with the state.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/colorado-payroll-img-sm.webp" />
                <source srcSet="/assets/images/colorado-payroll-img-sm.png" />
                <img
                  src="/assets/images/colorado-payroll-img-sm.png"
                  alt="Colorado Payroll Tax Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Colorado State Tax Filings
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            Employers in Colorado are required to file the below key form before
            the deadline to stay
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>{' '}
            compliant with the Colorado Department of Revenue (CDOR).
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontSize: { md: 22, sm: 20, xs: 18 },
              fontWeight: 600,
              mb: 2,
            }}
          >
            Employer Payroll tax forms:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Link
                href="https://newhire.state.co.us/downloads/CO_NH_reporting.pdf"
                target="_blank"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    // mx: 'auto',
                    p: 3,
                    background:
                      'linear-gradient(99deg,rgba(255, 255, 255, 0.78) 50%, rgba(10, 117, 129, 0.19) 100%)',
                    border: 'none',
                    borderRadius: 8,
                    minHeight: '100%',
                    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;',
                      transform: 'translateY(-10px)',
                    },
                  }}
                >
                  <Box sx={{ p: 0 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 18 },
                      }}
                    >
                      Form NHR
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                      New Hire Reporting
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      All employers who hire or rehire employees in Colorado
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Within 20 days of hire date
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 48, sm: 34, xs: 28 },
                      }}
                    >
                      20 Days
                    </Typography>
                  </Box>
                </Paper>
              </Link>
            </Grid>{' '}
          </Grid>
          <Typography
            variant="h3"
            sx={{
              fontSize: { md: 22, sm: 20, xs: 18 },
              fontWeight: 600,
              mb: 2,
            }}
          >
            Information return:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Link
                href="/form-w2-state-filing/colorado-w-2-filing-requirements/"
                target="_blank"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    // mx: 'auto',
                    p: 3,
                    background:
                      'linear-gradient(99deg,rgba(255, 255, 255, 0.78) 20%, rgba(18, 192, 255, 0.19) 100%)',
                    border: 'none',
                    borderRadius: 8,
                    minHeight: '100%',
                    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;',
                      transform: 'translateY(-10px)',
                    },
                  }}
                >
                  <Box sx={{ p: 0 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 18 },
                      }}
                    >
                      CO Form W-2
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Wage and Tax Statement
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Employers who pay wages subject to Colorado income tax
                      withholding
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 48, sm: 34, xs: 28 },
                      }}
                    >
                      January 31
                    </Typography>
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Link
                href="https://tax.colorado.gov/sites/tax/files/documents/DR_1093_2024.pdf"
                target="_blank"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    // mx: 'auto',
                    p: 3,
                    background:
                      'linear-gradient(99deg,rgba(255, 255, 255, 0.78) 20%, rgba(18, 192, 255, 0.19) 100%)',
                    border: 'none',
                    borderRadius: 8,
                    minHeight: '100%',
                    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;',
                      transform: 'translateY(-10px)',
                    },
                  }}
                >
                  <Box sx={{ p: 0 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 18 },
                      }}
                    >
                      Form DR 1093
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Annual Transmittal of State W-2 Forms
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      All employers who withhold Colorado income tax
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 48, sm: 34, xs: 28 },
                      }}
                    >
                      January 31
                    </Typography>
                  </Box>
                </Paper>
              </Link>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Link
                href="/form-1099-state-filing/colorado-filing-requirements/"
                target="_blank"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    // mx: 'auto',
                    p: 3,
                    background:
                      'linear-gradient(99deg,rgba(255, 255, 255, 0.78) 20%, rgba(18, 192, 255, 0.19) 100%)',
                    border: 'none',
                    borderRadius: 8,
                    minHeight: '100%',
                    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;',
                      transform: 'translateY(-10px)',
                    },
                  }}
                >
                  <Box sx={{ p: 0 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 20, sm: 18, xs: 18 },
                      }}
                    >
                      CO Form 1099-NEC
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Nonemployee Compensation
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Businesses making payments to contractors or nonemployees
                      within Colorado
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 48, sm: 34, xs: 28 },
                      }}
                    >
                      January 31
                    </Typography>
                  </Box>
                </Paper>
              </Link>
            </Grid>{' '}
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                Colorado Unemployment Tax (SUI)
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                In Colorado, employers must pay{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  State Unemployment Insurance (SUI)
                </span>{' '}
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                taxes to support workers who lose their jobs through no fault of
                their own.
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 7 }}>
            <Box component="div" sx={{ mb: 3 }}>
              <TableContainer sx={{ border: '1px solid #828282' }}>
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#ccc' }}>
                      <TableCell
                        colSpan={2}
                        sx={{
                          color: '#444',
                          width: 200,
                          fontWeight: 600,
                          fontSize: 18,
                          textAlign: 'center',
                        }}
                      >
                        Colorado UI Tax Rates (2025)
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow sx={{}}>
                      <TableCell>Taxable Wage Base</TableCell>

                      <TableCell>$27,200 </TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                      <TableCell>Experienced employer rates</TableCell>

                      <TableCell>0.64% to 8.68% </TableCell>
                    </TableRow>
                    <TableRow sx={{}}>
                      <TableCell>New employer rate </TableCell>

                      <TableCell>1.7%</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: 24, md: 20, sm: 18, xs: 16 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
              }}
            >
              UI Tax Form and Due Dates
            </Typography>
            <Box component="div" sx={{ mb: 3 }}>
              <TableContainer sx={{ border: '1px solid #828282' }}>
                <Table aria-label="Due Date Chart">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#ccc' }}>
                      <TableCell
                        sx={{
                          color: '#444',
                          width: 200,
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Form Name
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          width: 220,
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Due Date
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          verticalAlign: 'top',
                        }}
                      >
                        Form UITR-1
                      </TableCell>

                      <TableCell sx={{ verticalAlign: 'top' }}>
                        Q1: <span style={{ fontWeight: 600 }}>April 30</span>
                        <br />
                        Q2: <span style={{ fontWeight: 600 }}>July 31</span>
                        <br />
                        Q3: <span style={{ fontWeight: 600 }}>October 31</span>
                        <br />
                        Q4: <span style={{ fontWeight: 600 }}>January 31</span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone Can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How does TaxZerone help you file?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                  TaxZerone simplifies your tax filing process by supporting{' '}
                  <span style={{ fontWeight: 600 }}>federal forms</span> and
                  providing clear guidance on{' '}
                  <span style={{ fontWeight: 600 }}>state</span> payroll filing
                  requirements. We help you stay compliant, avoid penalties, and
                  file accurately with confidence.
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    mb: 2,
                    fontSize: 13,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <b> Note:</b> TaxZerone supports{' '}
                  <Link
                    href="/form-w2-state-filing/colorado-w-2-filing-requirements/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Colorado W-2 form
                  </Link>{' '}
                  and{' '}
                  <Link
                    href="/form-1099-state-filing/colorado-filing-requirements/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Colorado 1099-NEC form
                  </Link>
                  . Visit these pages for more details on requirements and
                  deadlines.
                </Alert>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What are the details required to file DE 9 and DE 9C?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    You can file Colorado taxes electronically through:
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                    <li>
                      {' '}
                      <Link
                        href="https://www.colorado.gov/revenueonline"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Colorado Department of Revenue (CDOR)
                      </Link>{' '}
                    </li>
                    <li>
                      <Link
                        href="https://cdle.colorado.gov/employers/myui-employer-plus"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Colorado Department of Labor and Employment (CDLE)
                      </Link>
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do I need to report new hires in Colorado?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                      Yes, all employers are required to submit{' '}
                      <span style={{ fontWeight: 600 }}>
                        New Hire Reports (Form NHR)
                      </span>{' '}
                      within <span style={{ fontWeight: 600 }}>20 days</span> of
                      hiring or rehiring an employee. This helps the state track
                      employment and enforce child support orders.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What happens if I file my Colorado payroll taxes late?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      Late filings may result in penalties. Filing on time helps
                      you avoid these additional costs and maintain a good
                      standing with the state.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default EmploynmentStateArkansas;
